<h2>{{ tableHeader | translate }}</h2>
<app-chart-download-button (buttonClick)="exportTable()">
  <h3>{{ "m1-m2.sprint8.cockpit.card.personalbestand.anzahlMitarbeitendeGrundgesamtheit.table" | translate }}</h3>
</app-chart-download-button>

<div class="table-wrapper">
  @if (anzahlMitarbeitendeNachGrundgesamtheit) {
    <table style="margin-bottom: 50px" id="anzahlMitarbeitendeGrundgesamtheit">
      <thead>
        <tr>
          <td class="no-border"><br /></td>
          <th scope="colgroup" colspan="3" class="border-bold-left border-bold-right header centered bold border-bold-left border-bold-right bold centered">{{ "i18n.common.anzahl" | translate }}</th>
        </tr>
        <tr>
          <td class="border-bold-left border-bold-right header centered bold border-bold-left border-bold-right bold centered">{{ "m1-m2.sprint8.cockpit.card.Personalbestand.content1" | translate }}</td>
          <th scope="col" class="centered">{{ "i18n.common.gesamt" | translate }}</th>
          <th scope="col" class="centered">{{ "i18n.common.maenner" | translate }}</th>
          <th scope="col" class="border-bold-right border-bold-right centered">{{ "i18n.common.frauen" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="content">
          <th scope="row" class="border-bold-left border-bold-right">
            {{ "m1-m2.sprint8.cockpit.card.chart.Personalbestand.regulaererArbeitsvertrag" | translate }}
          </th>
          <td class="text-align-right">
            {{ anzahlMitarbeitendeNachGrundgesamtheit.regulaererArbeitsVertrag.anzahlGesamt || 0 }}
          </td>
          <td class="text-align-right">
            {{ anzahlMitarbeitendeNachGrundgesamtheit.regulaererArbeitsVertrag.anzahlMaenner || 0 }}
          </td>
          <td class="border-bold-right border-bold-right text-align-right">
            {{ anzahlMitarbeitendeNachGrundgesamtheit.regulaererArbeitsVertrag.anzahlFrauen || 0 }}
          </td>
        </tr>
        <tr class="content">
          <th scope="row" class="border-bold-left border-bold-right text-align-left italic indented">
            {{ "m1-m2.sprint8.cockpit.card.chart.Personalbestand.davonDatensaetzeUngueltigenWerten" | translate }}
          </th>
          <td class="text-align-right">{{ anzahlMitarbeitendeNachGrundgesamtheit.davonUngueltig.anzahlGesamt || 0 }}</td>
          <td class="text-align-right">{{ anzahlMitarbeitendeNachGrundgesamtheit.davonUngueltig.anzahlMaenner || 0 }}</td>
          <td class="border-bold-right border-bold-right text-align-right">
            {{ anzahlMitarbeitendeNachGrundgesamtheit.davonUngueltig.anzahlFrauen || 0 }}
          </td>
        </tr>
        <tr class="content">
          <th scope="row" class="border-bold-left border-bold-right">
            {{ "m1-m2.sprint8.cockpit.card.chart.Personalbestand.berufslehre" | translate }}
          </th>
          <td class="text-align-right">{{ anzahlMitarbeitendeNachGrundgesamtheit.berufslehre.anzahlGesamt || 0 }}</td>
          <td class="text-align-right">{{ anzahlMitarbeitendeNachGrundgesamtheit.berufslehre.anzahlMaenner || 0 }}</td>
          <td class="border-bold-right border-bold-right text-align-right">
            {{ anzahlMitarbeitendeNachGrundgesamtheit.berufslehre.anzahlFrauen || 0 }}
          </td>
        </tr>
        <tr class="content">
          <th scope="row" class="border-bold-left border-bold-right">
            {{ "m1-m2.sprint8.cockpit.card.chart.Personalbestand.praktikum" | translate }}
          </th>
          <td class="text-align-right">{{ anzahlMitarbeitendeNachGrundgesamtheit.praktikum.anzahlGesamt || 0 }}</td>
          <td class="text-align-right">{{ anzahlMitarbeitendeNachGrundgesamtheit.praktikum.anzahlMaenner || 0 }}</td>
          <td class="border-bold-right border-bold-right text-align-right">
            {{ anzahlMitarbeitendeNachGrundgesamtheit.praktikum.anzahlFrauen || 0 }}
          </td>
        </tr>
        <tr class="content">
          <th scope="row" class="border-bold-left border-bold-right">
            {{ "m1-m2.sprint8.cockpit.card.chart.Personalbestand.expatSchweizerVertrag" | translate }}
          </th>
          <td class="text-align-right">{{ anzahlMitarbeitendeNachGrundgesamtheit.expat.anzahlGesamt || 0 }}</td>
          <td class="text-align-right">{{ anzahlMitarbeitendeNachGrundgesamtheit.expat.anzahlMaenner || 0 }}</td>
          <td class="border-bold-right border-bold-right text-align-right">
            {{ anzahlMitarbeitendeNachGrundgesamtheit.expat.anzahlFrauen || 0 }}
          </td>
        </tr>
        <tr class="content">
          <th scope="row" class="border-bold-left border-bold-right">
            {{ "m1-m2.sprint8.cockpit.card.chart.Personalbestand.anderes" | translate }}
          </th>
          <td class="text-align-right">{{ anzahlMitarbeitendeNachGrundgesamtheit.anderes.anzahlGesamt || 0 }}</td>
          <td class="text-align-right">{{ anzahlMitarbeitendeNachGrundgesamtheit.anderes.anzahlMaenner || 0 }}</td>
          <td class="border-bold-right border-bold-right text-align-right">
            {{ anzahlMitarbeitendeNachGrundgesamtheit.anderes.anzahlFrauen || 0 }}
          </td>
        </tr>
        <tr class="content">
          <th scope="row" class="border-bold-left border-bold-right border-bold-top">
            {{ "m1-m2.sprint8.cockpit.card.chart.Personalbestand.gesamt" | translate }}
          </th>
          <td class="text-align-right border-bold-top">{{ anzahlMitarbeitendeNachGrundgesamtheit.gesamt.anzahlGesamt || 0 }}</td>
          <td class="text-align-right border-bold-top">{{ anzahlMitarbeitendeNachGrundgesamtheit.gesamt.anzahlMaenner || 0 }}</td>
          <td class="border-bold-right border-bold-right text-align-right border-bold-top">
            {{ anzahlMitarbeitendeNachGrundgesamtheit.gesamt.anzahlFrauen || 0 }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="hint">
          <td class="hint" colspan="4">
            {{
            "m1-m2.sprint8.cockpit.card.personalbestand.card.anzahlMitarbeitendeGrundgesamtheit.basis-text" | translate
            }}
          </td>
        </tr>
      </tfoot>
    </table>
  }
</div>
